function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChartUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75002 3C2.78352 3 2.00002 3.7835 2.00002 4.75V13.5C2.00002 14.4665 2.78352 15.25 3.75002 15.25H14.25C15.2165 15.25 16 14.4665 16 13.5V4.75C16 3.7835 15.2165 3 14.25 3H3.75002ZM9.85953 5.71236C9.49709 5.71236 9.20328 6.00618 9.20328 6.36861C9.20328 6.73105 9.49709 7.02486 9.85953 7.02486H11.6158L8.47502 10.1656L6.9703 8.66091C6.71402 8.40463 6.29851 8.40463 6.04223 8.66091L3.28598 11.4172C3.02969 11.6734 3.02969 12.089 3.28598 12.3452C3.54226 12.6015 3.95777 12.6015 4.21405 12.3452L6.50627 10.053L8.01098 11.5577C8.26726 11.814 8.68277 11.814 8.93905 11.5577L12.5444 7.95243V9.70969C12.5444 10.0721 12.8382 10.3659 13.2006 10.3659C13.563 10.3659 13.8569 10.0721 13.8569 9.70969V6.36861C13.8569 6.00618 13.563 5.71236 13.2006 5.71236H9.85953Z",
    fill: "url(#paint0_linear_2_4601)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75002 3C2.78352 3 2.00002 3.7835 2.00002 4.75V13.5C2.00002 14.4665 2.78352 15.25 3.75002 15.25H14.25C15.2165 15.25 16 14.4665 16 13.5V4.75C16 3.7835 15.2165 3 14.25 3H3.75002ZM9.85953 5.71236C9.49709 5.71236 9.20328 6.00618 9.20328 6.36861C9.20328 6.73105 9.49709 7.02486 9.85953 7.02486H11.6158L8.47502 10.1656L6.9703 8.66091C6.71402 8.40463 6.29851 8.40463 6.04223 8.66091L3.28598 11.4172C3.02969 11.6734 3.02969 12.089 3.28598 12.3452C3.54226 12.6015 3.95777 12.6015 4.21405 12.3452L6.50627 10.053L8.01098 11.5577C8.26726 11.814 8.68277 11.814 8.93905 11.5577L12.5444 7.95243V9.70969C12.5444 10.0721 12.8382 10.3659 13.2006 10.3659C13.563 10.3659 13.8569 10.0721 13.8569 9.70969V6.36861C13.8569 6.00618 13.563 5.71236 13.2006 5.71236H9.85953Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      fill: "white",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4601",
    x1: 8.23764,
    y1: 22.7148,
    x2: -3.02179,
    y2: 11.9475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB83",
    style: {
      stopColor: "#FFEB83",
      stopColor: "color(display-p3 1.0000 0.9216 0.5137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267088,
    stopColor: "#FFBF83",
    style: {
      stopColor: "#FFBF83",
      stopColor: "color(display-p3 1.0000 0.7490 0.5137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682213,
    stopColor: "#FD82FF",
    style: {
      stopColor: "#FD82FF",
      stopColor: "color(display-p3 0.9922 0.5098 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B283FF",
    style: {
      stopColor: "#B283FF",
      stopColor: "color(display-p3 0.6985 0.5137 1.0000)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartUpFilled);
export default __webpack_public_path__ + "static/media/line-chart-up-filled.fa88efd8a410acfdc8c6a68fe459fd67.svg";
export { ForwardRef as ReactComponent };